import o from "./de.mjs";
import r from "./en.mjs";
const t = {
  en: r,
  de: o
};
export {
  t as locales
};
//# sourceMappingURL=index.mjs.map
